import name from './name'

const selectSliceData = state => state[name]
const campaign = state => selectSliceData(state).campaign
const sections = state => selectSliceData(state).sections

export { campaign, sections }
